@if (formFieldSignal(); as formField) {
<!--    @if(errorState?.Message; as errorMessage){-->
<!--        <div class="absolute right-12 top-0 z-[1] flex h-full items-center justify-center">-->
<!--            <bizz-tooltip class="cursor-pointer text-red-400" [text]="errorMessage"></bizz-tooltip>-->
<!--        </div>-->
<!--    }-->
    <kendo-datetimepicker #input
            [class.error]="errorState?.AiValidationError === undefined && errorState != null"
            [class.errorYellow]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != null && errorState.AiValidationError"
            [value]="formControl.value"
            (valueChange)="onDataChange($event)"
            [ngClass]="{'hidden' : formField.IsHidden}"
            [placeholder]="''"
            [popupSettings]="{ animate: false }"
            [readonly]="readOnlyOverride || formField.IsReadOnly"
            [readOnlyInput]="readOnlyOverride || formField.IsReadOnly"
            tabIndex="-1"
            [format]="dateFormat"
            [adaptiveMode]="(isMobile | async) ? 'auto' : 'none'"
            [id]="'TabIDTimePicker'+ formField.Bookmark"
            (focus)="setCurrentDate()"
            (keydown)="hidePopup()"
            (open)="onPopupOpen()"
            (blur)="hidePopup()">
    </kendo-datetimepicker>
}

